import { CONSENTS, hasCookieConsentById } from "@/shared/scripts/ConsentManagementService";

(function () {
    if (!hasCookieConsentById(CONSENTS.REFINER)) {
        console.debug("[Refiner.io] Skipped loading due to missing consent.");
        return;
    }

    console.debug("[Refiner.io] Consent given, loading Refiner.io...");

    // Initialize global queue
    window._refinerQueue = window._refinerQueue || [];
    function _refiner() {
        window._refinerQueue.push(arguments);
    }

    // Expose globally
    window._refiner = _refiner;

    // Set project ID
    _refiner("setProject", "b529db80-a35d-11f0-9058-1d4775973f8c");

    // Inject Refiner.io client script
    (function () {
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.src = "https://js.refiner.io/v001/client.js";

        const firstScript = document.getElementsByTagName("script")[0];
        firstScript.parentNode.insertBefore(script, firstScript);
    })();
})();
